import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { NetWorthDTO } from './queryConsumerNetWorthWidget.types';
import { queryClient, QueryFeature } from '../../../../config/queryClient';
import { authFetch } from '../../../CommonUtils/authFetch';

enum QueryKey {
  NetWorthWidget = 'NetWorthWidget',
}

export const queryKeys = {
  NetWorthWidget: (clientId: string) => [
    QueryFeature.NetWorthWidget,
    QueryKey.NetWorthWidget,
    clientId.toString(),
  ],
};

const fetchNetWorthWidget = (clientId: string): Promise<NetWorthDTO> => {
  return authFetch(
    urlWithParams('/Consumer/NetworthWidget', {
      clientId,
      isPresentationMode: ADV.info.isPresentationMode,
    }),
  );
};

export const queryConsumerNetWorthWidget = async (clientId: string) => {
  if (!queryClient.getQueryData(queryKeys.NetWorthWidget(clientId))) {
    return queryClient.fetchQuery(queryKeys.NetWorthWidget(clientId), () =>
      fetchNetWorthWidget(clientId),
    );
  }

  await queryClient.refetchQueries(queryKeys.NetWorthWidget(clientId));

  return queryClient.getQueryData(queryKeys.NetWorthWidget(clientId));
};
